module.exports = __webpack_public_path__ + "img/svg/background-user-profile.7d1dafa58f7d8a4cbe3ce7fe92fa8722.svg";